import React from 'react';
import { Flex, Text, Button } from '@chakra-ui/react';
import { Modal } from '@morressier/alembic';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onRemove: () => void;
  isLoading: boolean;
}

const RemoveNoteModal: React.FC<Props> = ({
  onRemove,
  isOpen,
  onClose,
  isLoading
}) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    width="450px"
    closeButtonProps={{
      hidden: true
    }}
  >
    <Flex flexDirection="column" gap={6} padding={8}>
      <Flex flexDirection="column" gap={2}>
        <Text textStyle="headingGroup">Delete Note?</Text>
        <Text textStyle="textBody">This action is irreversible.</Text>
      </Flex>

      <Flex flexDirection="row" gap={2} justifyContent="end">
        <Button onClick={onClose} isDisabled={isLoading}>
          Cancel
        </Button>
        <Button
          variant="caution"
          onClick={onRemove}
          isDisabled={isLoading}
          isLoading={isLoading}
        >
          Delete
        </Button>
      </Flex>
    </Flex>
  </Modal>
);

export default RemoveNoteModal;
